import styled from 'styled-components';
import { Image as SemanticImage } from 'semantic-ui-react';
import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

const Button = styled.button`
  background-color: white;
  border: 1px solid black;
  padding: 5px 15px;
  font-size: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border-radius: 4px;
  cursor: pointer;
`;

const Title = styled(TextLayoutComponent.Header)``;

const Image = styled(SemanticImage)`
  width: 12px;
`;

export {
  Button,
  Image,
  Title,
};
